window.addEventListener('load', function () {
    // Function to check for a valid SKU and retry if not found
    function waitForValidSku(retriesLeft = 3) {
      
        try {
            // Check if a valid SKU exists in sellerProductVariants
            const validSku = sellerProductVariants.find(variant => variant.skuId && variant.skuId.trim() !== "");
            
            if (validSku) {
                //console.log("Valid SKU found:", validSku.skuId);
                setTimeout(() => {
                    widgetSetup(); // Call widgetSetup after the delay
                }, 2);
            } else if (retriesLeft > 0) {
                //console.warn(`No valid SKU found. Retrying... (${retriesLeft} attempts left)`);
                setTimeout(() => waitForValidSku(retriesLeft - 1), 1000); // Retry after 1 second
            } else {
                console.error("No valid SKU found after maximum retries.");
            }
        } catch (error) {
            //console.error("Error during SKU check:", error);
            if (retriesLeft > 0) {
                setTimeout(() => waitForValidSku(retriesLeft - 1), 1000); // Retry on error
            } else {
                console.error("Error persisted after maximum retries.");
            }
        }
    }

    // Start checking for a valid SKU after the page has fully loaded
    waitForValidSku();
});

window.addEventListener('load', function () {
    let skuUpdateTimeout;

    function customizeWidgetBasedOnSKU() {
      const shadowHost = document.querySelector('#delivery-promise-container');
      const skuElement = document.querySelector('[data-sku-id]');
      const productTags = window.productTags || [];
  
      if (!skuElement) {
          console.log("SKU element not found.");
          return;
      }
  
      const sku = skuElement.textContent.trim(); // Get the current SKU text
      console.log("Current SKU:", sku);
  
      if (shadowHost && shadowHost.shadowRoot) {
          const shadowRoot = shadowHost.shadowRoot;
  
          // Get the elements for the additional conditions
          const testDdpZipcode = shadowRoot.querySelector('[data-testid="test-ddp-zipcode"]');
          const ddpDateElement = shadowRoot.querySelector('#ddp-date');
  
          // Check conditions:
          // 1. 'MCF' not included in productTags
          // OR
          // 2. test-ddp-zipcode is present and not empty AND ddp-date does not exist.
          if (
              !productTags.includes('MCF') ||
              (testDdpZipcode && testDdpZipcode.textContent.trim() !== '' && !ddpDateElement)
          ) {
              // Insert custom message into .grid-container
              //console.log("Condition met (No MCF tag or test-ddp-zipcode/No ddp-date). Inserting custom message into .grid-container.");
  
              let gridContainerElement = shadowRoot.querySelector('.grid-container');
  
              // If .grid-container doesn't exist, create it
              if (!gridContainerElement) {
                  gridContainerElement = document.createElement('div');
                  gridContainerElement.classList.add('grid-container');
                  // Apply styles
                  gridContainerElement.style.display = 'block';
                  gridContainerElement.style.justifyContent = 'center';
                  gridContainerElement.style.borderRadius = '50px';
                  gridContainerElement.style.background = '#F6F6F6';
                  gridContainerElement.style.padding = '10px';
                  gridContainerElement.style.marginTop = '10px';
  
                  shadowRoot.appendChild(gridContainerElement);
              } else {
                  // If it exists, clear its content
                  gridContainerElement.innerHTML = '';
              }
  
              // Create a new div for your message
              const customMessageDiv = document.createElement('div');
              customMessageDiv.id = 'custom-message';
              customMessageDiv.style.textAlign = 'center';
  
              // Create a new span for your message text
              const customMessageSpan = document.createElement('span');
              customMessageSpan.textContent = 'Ships Within 1 Business Day';
              customMessageSpan.style.fontSize = '16px';
              customMessageSpan.style.color = '#000';
  
              // Append the message span to the message div
              customMessageDiv.appendChild(customMessageSpan);
  
              // Append the custom message div to the grid container
              gridContainerElement.appendChild(customMessageDiv);
          } else {
              // If the conditions are not met, show the original widget (MCF tag found)
              const dppEntryElement = shadowRoot.querySelector('.dpp-entry');
              const gridContainerElement = shadowRoot.querySelector('.grid-container');
  
              if (dppEntryElement) {
                  //console.log("'MCF' tag found or conditions not met. Showing '.dpp-entry' as normal.");
                  dppEntryElement.style.display = 'block';
                  dppEntryElement.style.justifyItems = 'center';
                  dppEntryElement.style.textAlign = 'center';
              }
              if (gridContainerElement) {
                  //console.log("Customizing '.grid-container'.");
                  gridContainerElement.style.justifyItems = 'center';
                  gridContainerElement.style.borderRadius = '50px';
                  gridContainerElement.style.background = '#F6F6F6';
                  gridContainerElement.style.textAlign = 'center';
                  gridContainerElement.style.minWidth = '100%';
                  if (window.innerWidth <= 768) { // Adjust this value based on your mobile breakpoint
                      gridContainerElement.style.marginLeft = '-10px'; // Example margin for mobile
                  }
              }
          }

              // If the conditions are not met, show the original widget (MCF tag found)
              const dppEntryElement = shadowRoot.querySelector('.dpp-entry');
              const gridContainerElement = shadowRoot.querySelector('.grid-container');
  
              if (dppEntryElement) {
                  //console.log("'MCF' tag found or conditions not met. Showing '.dpp-entry' as normal.");
                  dppEntryElement.style.display = 'block';
              }
              if (gridContainerElement) {
                  //console.log("Customizing '.grid-container'.");
                  gridContainerElement.style.justifyItems = 'center';
                  gridContainerElement.style.borderRadius = '50px';
                  gridContainerElement.style.background = '#F6F6F6';
              }
      } else {
          console.log("Shadow DOM not accessible.");
      }
  }

    function observeSKUChanges() {
        const targetNode = document.querySelector('.product-single__sku'); // Adjust this selector if necessary

        if (!targetNode) {
            console.log("SKU container not found. Waiting...");
            return;
        }

        const config = { childList: true, subtree: true };

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    //console.log("SKU changed. Scheduling widget customization.");

                    // Clear any previous timeout to prevent multiple updates
                    clearTimeout(skuUpdateTimeout);

                    // Schedule the widget customization with a delay
                    skuUpdateTimeout = setTimeout(() => {
                        customizeWidgetBasedOnSKU();
                    }, 1000); // 1-second delay
                }
            }
        });

        observer.observe(targetNode, config);
        console.log("Observing SKU changes.");
    }

    // Run on page load
    console.log("Page loaded. Initializing widget customization.");
    setTimeout(() => {
        customizeWidgetBasedOnSKU(); // Apply styling on page load
    }, 1000); // 1-second delay to ensure DOM is fully loaded

    observeSKUChanges(); // Observe subsequent changes
});




document.addEventListener('DOMContentLoaded', function() {
    const acc = document.getElementsByClassName("accordion2");

    for (let i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            const panel = this.nextElementSibling;
            
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });
    }
});
                          
document.addEventListener('DOMContentLoaded', function() {

    // Function to hide elements without images
    function hideElementsWithoutImages() {
        // Select all elements with IDs containing the specific string
        var elementsToHide = document.querySelectorAll('[id*="shopify-section-template--17219019473124__advanced_content_44Dx89"]');
    
        // Iterate over each selected element
        elementsToHide.forEach(function(element) {
            // Check if the current element contains an image element
            var imgElement = element.querySelector('img');
            
            // If there is no image element, hide the current element
            if (!imgElement) {
                element.style.display = 'none';
            }
        });
    }

    // Call the function to hide elements without images
    hideElementsWithoutImages();

    // Function to add knife details to bullet/sales point
    function addKnifeBullet(uniqueBladeShapes) {
      var defaultKnifeContainer = document.querySelector('.default-knife');
      var existingSalesPointDiv = document.querySelector('.product-block.product-block--sales-point');
    
      if (defaultKnifeContainer) {
        // Create a new div element with the class "product-block product-block--sales-point"
        var salesPointDiv = document.createElement('div');
        salesPointDiv.className = 'product-block product-block--sales-point';
        
        // Create a new div element with the class "icon-package-custom"
        var iconDiv = document.createElement('div');
        iconDiv.className = 'icon-package-custom';
        
        // Create a new SVG element with the provided path data and 20x20 size
        var svgMarkup = '<svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 64 64" width="20" height="20">' +
                        '<path fill="none" d="M0 0h64v64H0z"/>' +
                        '<path fill="black" fill-rule="nonzero" d="M11.579 3.755 59.661 51.84a4 4 0 0 1 -5.656 5.659l-12.256 -12.259L32.32 54.667l-20.741 -20.741a21.333 21.333 0 0 1 -0.464 -29.693l0.464 -0.477zm0.643 8.187 -0.136 0.293a16.013 16.013 0 0 0 2.792 17.427l0.472 0.493 16.968 16.968 7.544 -7.541L12.221 11.941z"/>' +
                        '</svg>';
        
        // Set the SVG markup as innerHTML for the icon div
        iconDiv.innerHTML = svgMarkup;
        
        // Append the icon div to the sales point div
        salesPointDiv.appendChild(iconDiv);
    
        // Access the unique blade shapes from the JavaScript variable
        for (var i = 0; i < uniqueBladeShapes.length; i++) {
          var currentBladeShape = uniqueBladeShapes[i];
          var currentBladeMaterial = uniqueBladeMaterials[i];
          var currentHandleMaterial = uniqueHandleMaterials[i];
          
          // Create a new span element with the blade shape text
          var bladeShapeSpan = document.createElement('span');
          bladeShapeSpan.textContent = currentBladeShape + ' / ' + currentBladeMaterial + ' / ' + currentHandleMaterial + ' Handle'; // Add a space after the blade shape text
          
          // Append the span element to the sales point div
          salesPointDiv.appendChild(bladeShapeSpan);
          
          // Create a new span element with the text "blade shape"
          var bladeShapeLabelSpan = document.createElement('span');
          bladeShapeLabelSpan.textContent = '';
          
          // Append the blade shape label span after the blade shape span
          salesPointDiv.appendChild(bladeShapeLabelSpan);
        }
        
        if (existingSalesPointDiv) {
          // If an existing sales point div exists, insert the new content before it
          existingSalesPointDiv.parentNode.insertBefore(salesPointDiv, existingSalesPointDiv);
        } else {
          // If no existing sales point div exists, insert the new content before the default knife container
          defaultKnifeContainer.parentNode.insertBefore(salesPointDiv, defaultKnifeContainer);
        }
      }
    }

    // Call the function to add knife bullet if unique blade shapes exist
    if (typeof uniqueBladeShapes !== 'undefined') {
        // addKnifeBullet(uniqueBladeShapes); TURN THIS BACK ON
    }  
});


  // Check if the element with id="defaultOpen" exists
  var defaultOpenButton = document.getElementById("defaultOpen");
  if (defaultOpenButton) {
      // If the element exists, click on it
      defaultOpenButton.click();
  }

  function openTab(evt, tabName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";

  // Get all elements with IDs that contain "shopify-section-template--"
  var elementsToShow = document.querySelectorAll('[id*="shopify-section-template--"]');
  
  // Show all previously hidden elements
  elementsToShow.forEach(function(element) {
      element.style.display = 'block';
  });
  
  // Get all elements with IDs that contain "shopify-section-template--"
  var elementsToHide = document.querySelectorAll('[id*="shopify-section-template--17215863128292__advanced_content_xJY4nB"]');

  // Hide the filtered elements
  elementsToHide.forEach(function(element) {
      element.style.display = 'none';
  });

  // Get all elements with IDs that contain "shopify-section-template--"
  var elementsToHide = document.querySelectorAll('[id*="shopify-section-template--17219019473124__advanced_content_YUxgba"]');

  // Hide the filtered elements
  elementsToHide.forEach(function(element) {
      element.style.display = 'none';
  });
}

  function openTabHide(evt, tabName) {
    // Get all elements with IDs that contain "shopify-section-template--"
    var elementsToHide = document.querySelectorAll('[id*="shopify-section-template--"]');
    
    // Filter out elements containing "main" or "XfwkPU"
    elementsToHide = Array.from(elementsToHide).filter(function(element) {
        return !element.id.includes('main') && !element.id.includes('XfwkPU') && !element.id.includes('xJY4nB') && !element.id.includes('3w7xBz') && !element.id.includes('YUxgba');
    });

    // Hide the filtered elements
    elementsToHide.forEach(function(element) {
        element.style.display = 'none';
    });

    // Get all elements with IDs that contain "shopify-section-template--"
    var elementsToShow = document.querySelectorAll('[id*="shopify-section-template--17215863128292__advanced_content_xJY4nB"]');
    
    // Show all previously hidden elements
    elementsToShow.forEach(function(element) {
        element.style.display = 'block';
    });

    // Get all elements with IDs that contain "shopify-section-template--"
    var elementsToShow = document.querySelectorAll('[id*="shopify-section-template--17219019473124__advanced_content_YUxgba"]');
    
    // Show all previously hidden elements
    elementsToShow.forEach(function(element) {
        element.style.display = 'block';
    });
    
    // Show the current tab and add the "active" class to the button that opened the tab
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
    }
    
    // Check if an element with ID "defaultOpen" exist
    if (document.getElementById("defaultOpen")) {
        // If the element exists, trigger the click event
        document.getElementById("defaultOpen").click();
    }

  
